import { collection, getDocs, query, updateDoc, doc, where } from 'firebase/firestore';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../../firebase';
import { designsCollection } from '../../utils';

const inputStyles =
    'mt-1 p-2 px-3 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring-3 focus:ring-indigo-200/50';

const BackfillCreatedAt = () => {
    const [productId, setProductId] = useState('');
    const [date, setDate] = useState('');
    const [status, setStatus] = useState(null);
    const [running, setRunning] = useState(false);

    const run = async () => {
        if (!productId || !date) return;
        setRunning(true);
        setStatus(null);

        const createdAt = new Date(date);
        const q = query(collection(db, designsCollection), where('product', '==', Number(productId)));
        const snap = await getDocs(q);

        let updated = 0;
        let skipped = 0;

        for (const docSnap of snap.docs) {
            if (docSnap.data().createdAt) {
                skipped++;
                continue;
            }
            await updateDoc(doc(db, designsCollection, docSnap.id), { createdAt });
            updated++;
        }

        setStatus({ updated, skipped, total: snap.size });
        setRunning(false);
    };

    return (
        <>
            <nav className="bg-gray-800 sticky top-0 shadow-lg z-50">
                <div className="mx-auto container px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 items-center justify-between">
                        <div className="flex items-center">
                            <div className="shrink-0">
                                <img src="/favicon.png" alt="Stickapp" className="size-8 inline" />{' '}
                                <h1 className="inline text-white font-medium text-xl ml-2">
                                    Stickapp <sup>v3</sup>
                                </h1>
                            </div>
                            <div className="hidden md:block">
                                <div className="ml-10 flex items-baseline space-x-4">
                                    <Link
                                        to="/admin/list"
                                        className="rounded-md px-3 py-2 uppercase text-xs font-medium text-gray-300 hover:bg-white/5 hover:text-white">
                                        Listado de diseños
                                    </Link>
                                    <Link
                                        to="/admin/create"
                                        className="rounded-md px-3 py-2 uppercase text-xs font-medium text-gray-300 hover:bg-white/5 hover:text-white">
                                        Nuevo diseño
                                    </Link>
                                    <Link
                                        to="/admin/tools/backfill-created-at"
                                        className="rounded-md bg-gray-900 px-3 py-2 uppercase text-xs font-medium text-gray-300 hover:bg-white/5 hover:text-white">
                                        Admin
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="hidden md:block">
                            <div className="ml-4 flex items-center md:ml-6">
                                <span className="text-xs uppercase right-1/2 top-0 text-gray-500">
                                    {designsCollection}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <div className="mx-auto container max-w-lg px-4 py-12">
                <h1 className="text-2xl font-semibold text-gray-700 mb-2">Backfill createdAt</h1>
                <p className="text-sm text-gray-500 mb-8">
                    Adds a <code className="bg-gray-100 px-1 rounded">createdAt</code> field to all designs of a
                    product that don't have one yet. Designs that already have the field are skipped.
                </p>

                <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 space-y-5">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">ID de producto</label>
                        <input
                            type="number"
                            className={inputStyles}
                            placeholder="Ej: 1234"
                            value={productId}
                            onChange={(e) => setProductId(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Fecha para createdAt</label>
                        <input
                            type="date"
                            className={inputStyles}
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </div>

                    <button
                        onClick={run}
                        disabled={running || !productId || !date}
                        className="w-full bg-etiquette text-white font-semibold py-2 px-4 rounded-md hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed transition-opacity">
                        {running ? 'Ejecutando…' : 'Ejecutar backfill'}
                    </button>
                </div>

                {status && (
                    <div className="mt-6 bg-green-50 border border-green-200 rounded-xl p-5 text-sm text-green-800 space-y-1">
                        <p className="font-semibold">Completado</p>
                        <p>Total de diseños encontrados: <strong>{status.total}</strong></p>
                        <p>Actualizados: <strong>{status.updated}</strong></p>
                        <p>Omitidos (ya tenían createdAt): <strong>{status.skipped}</strong></p>
                    </div>
                )}
            </div>
        </>
    );
};

export default BackfillCreatedAt;
